<section>
  <app-content-container>
    <div class="flex flex-col items-center">
      <div class="max-w-[800px] w-full">
        <h1 class="section-title font-bold text-center">
          Nossos últimos artigos
        </h1>

        <p class="w-full section-description leading-relaxed text-center mt-8">
          Artigos detalhados que cobrem Angular do zero ao avançado, Frontend
          moderno, boas práticas de desenvolvimento e os fundamentos mais
          importantes de Desenvolvimento Web.
        </p>
      </div>
      <div class="mt-28 flex justify-center flex-wrap gap-8 w-full">
        @for (item of blogPosts(); track item.guid) {
        <div class="action-card" data-testid="blog-post">
          <figure>
            <img class="card-image" [src]="item.image" [alt]="item.title" />
          </figure>
          <div class="card-body">
            <h2 class="card-title">{{ item.title }}</h2>

            <p class="mt-3">{{ item.description }}</p>

            <div class="card-actions mt-3">
              <a class="btn btn-primary w-full" [href]="item.link">
                Ler mais
              </a>
            </div>
          </div>
        </div>
        } @empty { @for (item of blogPostsLimit(); track item) {
        <div
          class="w-full max-w-[350px] h-[462px]"
          data-testid="blog-post-skeleton"
        >
          <div class="skeleton h-full w-full"></div>
        </div>
        } }
      </div>
    </div>
  </app-content-container>
</section>
